import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import UserProfile from '../components/UserProfile';
import { authAPI } from '../api/auth';
import { useNavigate } from 'react-router-dom';
import AnimatedLayout from '../components/AnimatedLayout';
import API from '../utils/api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchUserProfile = async () => {
    setLoading(true);
    try {
      const userData = await authAPI.getMe();
      setUser(userData);
      
      // Try to fetch user's business if they have one
      try {
        const businessRes = await API.get('/api/business/user-business');
        if (businessRes.data.business) {
          setBusiness(businessRes.data.business);
        }
      } catch (businessErr) {
        // User might not have a business, that's okay
        console.log('No business found for user');
        setBusiness(null);
      }
      
      setError(null);
    } catch (err) {
      setError('Failed to load profile data. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const handleProfileUpdate = () => {
    // Refresh user data after update
    fetchUserProfile();
  };

  if (loading) {
    return (
      <AnimatedLayout>
        <div className="flex items-center justify-center h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      </AnimatedLayout>
    );
  }

  if (error) {
    return (
      <AnimatedLayout>
        <div className="flex flex-col items-center justify-center h-screen p-4">
          <Card className="max-w-md w-full">
            <CardContent className="pt-6 text-center space-y-4">
              <Badge variant="destructive" className="text-base py-2 px-4">
                {error}
              </Badge>
              <Button 
                onClick={fetchUserProfile}
                className="w-full"
              >
                Try Again
              </Button>
            </CardContent>
          </Card>
        </div>
      </AnimatedLayout>
    );
  }

  return (
    <AnimatedLayout>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 max-w-4xl">
        <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 text-center text-gray-800 dark:text-white">
          My Profile
        </h1>
        
        {user && (
          <UserProfile 
            user={user} 
            onProfileUpdate={handleProfileUpdate}
            business={business}
          />
        )}
      </div>
    </AnimatedLayout>
  );
};

export default ProfilePage;